import React, { useState } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import { Link } from "react-router-dom";
import {
  Avatar,
  Box,
  TextField,
  Card,
  CardHeader,
  CardContent,
  Checkbox,
  Grid,
  Paper,
  TableContainer,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  Button,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import MultipleAudit from "./MultipleAudit";
import Template from "./Template";
import OS from "./OS";
import cron from "cron-validate";
import Alert from "@mui/material/Alert";
import IconButton from "@mui/material/IconButton";
import Collapse from "@mui/material/Collapse";
import CloseIcon from "@mui/icons-material/Close";
import FilterListIcon from "@mui/icons-material/FilterList";

const CustomerListResults = ({ customers, searchitems, ...rest }) => {
  const [selectedCustomerIds, setSelectedCustomerIds] = useState([]);
  const [selectedCustomerNames, setSelectedCustomerNames] = useState([]);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);
  const [open1, setOpen1] = React.useState(false);

  const [opensche, setOpensche] = React.useState(false);

  const handleSelectAll = (event) => {
    let newSelectedCustomerIds;
    let newSelectedCustomerNames;

    if (event.target.checked) {
      newSelectedCustomerIds = customers.map((customer) => customer.id);
      newSelectedCustomerNames = customers.map((customer) => customer.platform);
    } else {
      newSelectedCustomerIds = [];
      newSelectedCustomerNames = [];
    }
    setSelectedCustomerNames(newSelectedCustomerNames);
    setSelectedCustomerIds(newSelectedCustomerIds);
  };

  const uniqueTags = [];
  customers.map((cust) => {
    if (uniqueTags.indexOf(cust.id) === -1) {
      uniqueTags.push(cust.id);
    }
  });
  let uniquename = uniqueTags.filter((item, i, ar) => ar.indexOf(item) === i);

  const uniqueTagslen = uniqueTags.length;

  const handleSelectOne = (event, id, platform) => {
    const selectedIndex = selectedCustomerIds.indexOf(id);
    const selectedNameIndex = selectedCustomerNames.indexOf(platform);

    let newSelectedCustomerIds = [];
    let newSelectedCustomerNames = [];
    if (selectedIndex === -1) {
      newSelectedCustomerIds = newSelectedCustomerIds.concat(
        selectedCustomerIds,
        id
      );
    } else if (selectedIndex === 0) {
      newSelectedCustomerIds = newSelectedCustomerIds.concat(
        selectedCustomerIds.slice(1)
      );
    } else if (selectedIndex === selectedCustomerIds.length - 1) {
      newSelectedCustomerIds = newSelectedCustomerIds.concat(
        selectedCustomerIds.slice(0, -1)
      );
    } else if (selectedIndex > 0) {
      newSelectedCustomerIds = newSelectedCustomerIds.concat(
        selectedCustomerIds.slice(0, selectedIndex),
        selectedCustomerIds.slice(selectedIndex + 1)
      );
    }

    if (selectedNameIndex === -1) {
      newSelectedCustomerNames = newSelectedCustomerNames.concat(
        selectedCustomerNames,
        platform
      );
    } else if (selectedNameIndex === 0) {
      newSelectedCustomerNames = newSelectedCustomerNames.concat(
        selectedCustomerNames.slice(1)
      );
    } else if (selectedNameIndex === selectedCustomerNames.length - 1) {
      newSelectedCustomerNames = newSelectedCustomerNames.concat(
        selectedCustomerNames.slice(0, -1)
      );
    } else if (selectedNameIndex > 0) {
      newSelectedCustomerNames = newSelectedCustomerNames.concat(
        selectedCustomerNames.slice(0, selectedNameIndex),
        selectedCustomerNames.slice(selectedNameIndex + 1)
      );
    }
    setSelectedCustomerIds(newSelectedCustomerIds);
    setSelectedCustomerNames(newSelectedCustomerNames);
  };

  let uniqname = selectedCustomerNames.filter(
    (item, i, ar) => ar.indexOf(item) === i
  );
  const uniqnamelen = uniqname.length;

  const handleLimitChange = (event) => {
    setLimit(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const [selectedtemp, setSelectedtemp] = useState({
    temp_id: "",
    email: ""
  });

  const Audit = (hostId) => {
    // if (opensche) {
    var mail_id;
    if (selectedtemp.email === "") {
      mail_id = localStorage.getItem("email")
    } else {
      mail_id = selectedtemp.email.toString()
    }
    let audit = {
      host_id: hostId.toString(),
      temp_id: selectedtemp.temp_id.toString(),
      email: mail_id
    };
    fetch(`${process.env.REACT_APP_API_URL}/api/run_audit`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("token"),
      },
      body: JSON.stringify(audit),
    })
      .then((response) => response.json())
      .then((data) => {
        window.location.href = "/admin/audit";
        window.location.reload();
      })
      .catch((error) => {
        console.error(error);
      });
    // }
  };

  const handleClose1 = () => {
    setOpen1(false);
    window.location.reload();
  };

  const [platform, setplatform] = React.useState([]);

  React.useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/generics/platform/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((resp) => setplatform(resp))
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const [platformsearchitems, setPlatformsearchItems] = React.useState(0);

  const handleClicksearchplatform = (e) => {
    e.preventDefault;
    setPlatformsearchItems(e.target.value);
  };

  const [filterapply, setFilterapply] = React.useState(false);
  const [filteropen, setFilteropen] = React.useState(false);

  const handleClickFilterOpen = () => {
    setFilterapply(true);
    setFilteropen(true);
  };

  const handleFilterClose = () => {
    setFilteropen(false);
  };

  const handleClickFilterApply = () => {
    setFilteropen(false);
  };

  const handleClickFilterClear = () => {
    setPlatformsearchItems(0);
    setFilterapply(false);
    setFilteropen(false);
  };

  const cloumnName1 = "hostname";
  const cloumnName2 = "platform";

  return (
    <>
      <Collapse in={open1}>
        <Alert
          severity="error"
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
                setOpen1(false);
              }}
            >
              <CloseIcon onClick={handleClose1} fontSize="inherit" />
            </IconButton>
          }
          sx={{ mb: 2 }}
        >
          please Select similar OS names ....
        </Alert>
      </Collapse>
      <Dialog
        PaperProps={{
          sx: {
            width: "80%",
          },
        }}
        open={filteropen}
        onClose={handleFilterClose}
      >
        <DialogTitle>Filter</DialogTitle>
        <DialogContent>
          <Typography variant="h7" gutterBottom component="div">
            Platform:
          </Typography>
          <div className="relative flex flex-wrap items-stretch ml-2">
            <span className="z-10 h-full leading-snug font-normal absolute text-center text-blueGray-300 absolute bg-transparent rounded text-base items-center justify-center w-8 pl-3 py-3">
              <i className="fas fa-search"></i>
            </span>

            <input
              type="text"
              list="platforms"
              placeholder={
                platformsearchitems
                  ? platformsearchitems
                  : "Please choose the require Platform ..."
              }
              onChange={handleClicksearchplatform}
              className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white bg-white rounded text-sm shadow outline-none focus:outline-none focus:ring w-full pl-10"
            />
            <datalist id="platforms">
              {platform
                .filter((plat) => plat.cis_version === "OS")
                .map((val) => (
                  <option>{val.platform_name}</option>
                ))}
            </datalist>
          </div>
        </DialogContent>
        <DialogActions>
          {platformsearchitems ? (
            <Button
              color="error"
              variant="outlined"
              onClick={handleClickFilterClear}
            >
              Clear
            </Button>
          ) : (
            ""
          )}
          <Button variant="outlined" onClick={handleFilterClose}>
            Cancel
          </Button>
          <Button
            variant="contained"
            disabled={platformsearchitems ? false : true}
            onClick={handleClickFilterApply}
          >
            Apply
          </Button>
        </DialogActions>
      </Dialog>
      <Card {...rest}>
        <CardHeader
          action={
            <React.Fragment>
              <IconButton
                title="Filter"
                aria-label="Filter"
                id="filter"
                style={{ marginRight: "5px", color: "navy" }}
                variant="outlined"
                onClick={handleClickFilterOpen}
              >
                <FilterListIcon variant="outlined" />
              </IconButton>
              <MultipleAudit
                uniqname={uniqname}
                uniqnamelen={uniqnamelen}
                selectedIds={selectedCustomerIds}
                open1={open1}
                setOpen1={setOpen1}
              />
            </React.Fragment>
          }
          title="CONNECTED HOSTS"
        />
        <Paper sx={{ width: "100%" }}>
          <TableContainer sx={{ maxHeight: 1050 }}>
            <Table>
              <TableHead className="bg-lightBlue-200">
                <TableRow>
                  <TableCell align="center"></TableCell>
                  <TableCell align="center">S.No</TableCell>
                  <TableCell align="center">Host Name</TableCell>
                  <TableCell align="center">IP / DNS</TableCell>
                  <TableCell align="center">Platforms</TableCell>
                  <TableCell align="center">Run</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {customers
                  .filter((val) => {
                    if (filterapply) {
                      if (platformsearchitems == "") {
                        return val;
                      } else if (
                        val[cloumnName2]
                          .toLowerCase()
                          .includes(platformsearchitems.toLowerCase())
                      ) {
                        return val;
                      }
                    } else {
                      if (searchitems == "") {
                        return val;
                      } else if (
                        val[cloumnName1]
                          .toLowerCase()
                          .includes(searchitems.toLowerCase())
                      ) {
                        return val;
                      }
                    }
                  })
                  .slice(page * limit, page * limit + limit)
                  .map((customer) => (
                    <TableRow
                      hover
                      key={customer.id}
                      selected={selectedCustomerIds.indexOf(customer.id) !== -1}
                    >
                      <TableCell align="center" padding="checkbox">
                        <Checkbox
                          checked={
                            selectedCustomerIds.indexOf(customer.id) !== -1
                          }
                          onChange={(event) =>
                            handleSelectOne(
                              event,
                              customer.id,
                              customer.platform
                            )
                          }
                          value="true"
                        />
                      </TableCell>
                      <TableCell align="center">
                        {customer.serial_number}{" "}
                      </TableCell>
                      <TableCell align="center">{customer.hostname}</TableCell>
                      <TableCell align="center">{`${customer.ip_dns}`}</TableCell>
                      <TableCell align="center">
                        {customer.platform ? customer.platform : "-"}
                      </TableCell>
                      <TableCell align="center">
                        {window.localStorage.getItem("audit_run_access") ===
                        "You do not have permission to perform this action." ? (
                          ""
                        ) : (
                          <React.Fragment>
                            {window.localStorage.getItem("audit_run_limit") ===
                            "License limitation crossed" ? (
                              <React.Fragment>
                                {customer.status === "connected" ? (
                                  <Template
                                    HostID={customer.id}
                                    Audit={Audit}
                                    setSelectedtemp={setSelectedtemp}
                                    opensche={opensche}
                                    setOpensche={setOpensche}
                                  />
                                ) : (
                                  <button
                                    className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                                    type="button"
                                    disabled="true"
                                  >
                                    Run Audit
                                  </button>
                                )}
                              </React.Fragment>
                            ) : (
                              <React.Fragment>
                                {customer.status === "connected" ? (
                                  <Template
                                    HostID={customer.id}
                                    Audit={Audit}
                                    setSelectedtemp={setSelectedtemp}
                                    opensche={opensche}
                                    setOpensche={setOpensche}
                                  />
                                ) : (
                                  <button
                                    className="bg-blueGray-200 text-white active:bg-lightBlue-600 font-bold text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                                    type="button"
                                    disabled="true"
                                  >
                                    Run Audit
                                  </button>
                                )}
                              </React.Fragment>
                            )}
                          </React.Fragment>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
        <TablePagination
          component="div"
          count={customers.length}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleLimitChange}
          page={page}
          rowsPerPage={limit}
          rowsPerPageOptions={[5, 10, 25]}
        />
      </Card>
    </>
  );
};

export default CustomerListResults;